import React from 'react';
import { NavLink } from 'react-router-dom';
import './styles.scss';
import { CreditCard } from "../../../services/dto/Security";
import { TodoItem } from "../LeftStepList";
import { Box, Typography, Button, Paper, FormControlLabel, Checkbox } from '@mui/material';
import { useHistory } from 'react-router-dom';

export interface ISessionSummaryProps {
  copayValue: number
  card?: CreditCard,
  steps: TodoItem[]
}

export const SessionSummary: React.FunctionComponent<ISessionSummaryProps> = (props) => {  
  const { copayValue, card, steps } = props;
  const displayCopay = typeof copayValue === "string" ? copayValue : (copayValue || 0).toFixed(2)
  const history = useHistory();
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <Paper sx={{ p: 2, width: { sm: '100%', md: '600px' } }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <Typography variant="h5" fontWeight="bold">Here is summary of your consultation</Typography>
          <div className="check-list">
            {steps.map((item, index) => (
              <div className="check-row" key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={item.completed}
                      disabled
                    />
                  }
                  label={item.title}
                />
              </div>
            ))}
          </div>
          <Typography variant="h6" fontWeight="bold">
            Copay: ${displayCopay}
          </Typography>
          {card && (
            <Typography variant="h6" fontWeight="bold">
              Billed to {card.number}
            </Typography>
          )}
          {/* TODO: Add receipt request */}
          {/* <Button variant="text" color="primary" href="#javascript">
            Request a receipt
          </Button> */}
        </Box>
      </Paper>
      <Button
        variant="contained"
        size="large"
        onClick={() => history.push("/patientDashboardPage")}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default SessionSummary;
